import React from "react";

import { Button } from "@mui/material";

import CommentIcon from "@mui/icons-material/Comment";
import CommentsDialog from "../../../../components/Dialogs/CommentsDialog";

export default function CommentsBtn({ data }) {
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <Button
        variant="outlined"
        onClick={() => setOpen(true)}
        endIcon={<CommentIcon />}
        sx={{ mx: 0.5 }}
      >
        Comments
      </Button>
      <CommentsDialog
        open={open}
        handleClose={() => {
          setOpen(false);
        }}
        parentId={data?.mrqId + "_" + data?.vendorId}
        parentType="bid"
        sender={{ name: data?.vendorName }}

        // isNotDialog={true}
      />
    </>
  );
}
